import { renderPage } from "renderPage"
import { ClubPartnerShowPage } from "./Page"

renderPage({ component: ClubPartnerShowPage })
